<template>
  <div v-if="freeDays && freeDays.length > 0">
    Fees are wavied at this site on the following days:
    <ul>
      <div>
        <li v-for="(day, index) in freeDays" :key="index">
          {{ formatDate(day) }}: {{ day.name }}
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["freeDays"],
  methods: {
    formatDate(day) {
      if (day.end) {
        return (
          moment.utc(day.date).format("MMMM Do") +
          " - " +
          moment.utc(day.end).format("MMMM Do YYYY")
        );
      } else {
        return moment.utc(day.date).format("MMMM Do YYYY");
      }
    }
  }
};
</script>
